/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const maxPayByBonusesRequestSchema = z.object({
	order_id: z.uuid(),
});
